import React from "react";
import ButtonTextOnly from "../../../../commons/Buttons/ButtonTextOnly";
import { Container, Wrapper } from "./styled";
import colors from "../../../../../styles/colorPalette";
import { useHistory } from "react-router-dom";
import { PATH_REQUEST } from "../../../App/constants";
import { useSelector } from "react-redux";
import { selectedArticles, totalAmount } from "../../../../../store/Concept/selectors";

const Button = () => {
  const history = useHistory();
  const items = useSelector(selectedArticles);
  const total = useSelector(totalAmount);
  const tot = parseInt(total);
  const disabled = items.length === 0 || tot === 0;

  const goToView = () => {
    history.push(PATH_REQUEST);
  };

  return (
    <Wrapper>
      <Container>
        <ButtonTextOnly
          disabled={disabled}
          onClick={goToView}
          background={colors.blue1}
          color={colors.gray1}
          text={"Generar cupón"}
        />
      </Container>
    </Wrapper>
  );
};

export default Button;
